export default __webpack_public_path__ + "static/media/support-us.bbef6c94.avif";